<div class="flex flex-col gap-4 text-gray-700">
	<p>Deleting a request will send you right back to the start.</p>

	<p>
		All individuals with access to client intake form will no longer be able to
		view it as it will be deleted.
	</p>
</div>
